// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from './axios'
Vue.prototype.$axios = axios
import lang from './utils/i18n.js'
console.log(lang);

import { Upload } from 'element-ui';
Vue.use(Upload);

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2, {
  confirmButtonColor: '#8cd4f5',
  cancelButtonColor: '#ff7674',
});
import echarts from 'echarts'
Vue.prototype.$echarts = echarts;

Vue.prototype.$t = function (text) {
  if (store.state.i18n == 'zh_CN') {
    return text;
  } else {
    if (lang.hasOwnProperty(text)) {
      return lang[text][store.state.i18n];
    } else {
      console.log(text + '不存在' + store.state.i18n + '翻译');
      return undefined;
    }
  }
}

Vue.prototype.$t2 = function (text) {
  let lang = {
    '大': {
      'zh_TW': '大',
      'en_US': 'Big',
    },
    '小': {
      'zh_TW': '小',
      'en_US': 'Small',
    },
    '单': {
      'zh_TW': '單',
      'en_US': 'Odd',
    },
    '双': {
      'zh_TW': '雙',
      'en_US': 'Even',
    },
    '龙': {
      'zh_TW': '龍',
      'en_US': 'Dragon',
    },
    '虎': {
      'zh_TW': '虎',
      'en_US': 'Tiger',
    },
    '和': {
      'zh_TW': '和',
      'en_US': 'Tie',
    },
    '上': {
      'zh_TW': '上',
      'en_US': 'Up',
    },
    '下': {
      'zh_TW': '下',
      'en_US': 'Down',
    },
    '中': {
      'zh_TW': '中',
      'en_US': 'Mid',
    },
    '大单': {
      'zh_TW': '大單',
      'en_US': 'BigOdd',
    },
    '质': {
      'zh_TW': '質',
      'en_US': 'Prime',
    },
    '合': {
      'zh_TW': '合',
      'en_US': 'Composite',
    },
    '小单': {
      'zh_TW': '小單',
      'en_US': 'SmallOdd',
    },
    '大双': {
      'zh_TW': '大雙',
      'en_US': 'BigEven',
    },
    '小双': {
      'zh_TW': '小雙',
      'en_US': 'SmallEven',
    },
    '金': {
      'zh_TW': '金',
      'en_US': 'Metal',
    },
    '木': {
      'zh_TW': '木',
      'en_US': 'Wood',
    },
    '水': {
      'zh_TW': '水',
      'en_US': 'Water',
    },
    '火': {
      'zh_TW': '火',
      'en_US': 'Fire',
    },
    '土': {
      'zh_TW': '土',
      'en_US': 'Earth',
    },
    '龙:1st': {
      'zh_TW': '龍:1st',
      'en_US': 'Dragon:1st',
    },
    '虎:5th': {
      'zh_TW': '虎:5th',
      'en_US': 'Tiger:5th',
    },
    '单0双5': {
      'zh_TW': '單0雙5',
      'en_US': 'Odd0Even5',
    },
    '单1双4': {
      'zh_TW': '單1雙4',
      'en_US': 'Odd1Even4',
    },
    '单2双3': {
      'zh_TW': '單2雙3',
      'en_US': 'Odd2Even3',
    },
    '单3双2': {
      'zh_TW': '單3雙2',
      'en_US': 'Odd3Even2',
    },
    '单4双1': {
      'zh_TW': '單4雙1',
      'en_US': 'Odd4Even1',
    },
    '单5双0': {
      'zh_TW': '單5雙0',
      'en_US': 'Odd5Even0',
    },
    '顺子': {
      'zh_TW': '順子',
      'en_US': 'Straight',
    },
    '半顺': {
      'zh_TW': '半順',
      'en_US': 'Half Straight',
    },
    '新牌': {
      'zh_TW': '新牌',
      'en_US': 'Ragged',
    },
  };

  if (this.$store.state.i18n == 'zh_CN') {
    return text;
  } else {
    if (lang.hasOwnProperty(text)) {
      return lang[text][this.$store.state.i18n];
    } else {
      console.log(text + '不存在' + this.$store.state.i18n + '翻译');
      return undefined;
    }
  }
}

Vue.prototype.$time = function (timestamp) {
  var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = date.getDate() + ' ';
  var h = date.getHours() + ':';
  var m = date.getMinutes() + ':';
  var s = date.getSeconds();
  if (D < 10) {
    D = '0' + D;
  }
  if (h < 10) {
    h = '0' + h;
  }
  if (m < 10) {
    m = '0' + m;
  }
  if (s < 10) {
    s = '0' + s;
  }
  return Y + M + D + h + m + s;
};

Vue.prototype.$getToday = function (field) {
  if (field == 'start') {
    var day2 = new Date();
    day2.setTime(day2.getTime());
    var y = day2.getFullYear();
    var m = (day2.getMonth() + 1);
    var d = day2.getDate();
    if (m < 10) {
      m = '0' + m;
    }
    if (d < 10) {
      d = '0' + d;
    }
    var s2 = y + "-" + m + "-" + d;
    return s2;
  } else {
    var day3 = new Date();
    day3.setTime(day3.getTime() + 24 * 60 * 60 * 1000);
    var y = day3.getFullYear();
    var m = (day3.getMonth() + 1);
    var d = day3.getDate();
    if (m < 10) {
      m = '0' + m;
    }
    if (d < 10) {
      d = '0' + d;
    }
    var s3 = y + "-" + m + "-" + d;

    return s3;
  }

}
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js